module.exports = __webpack_public_path__ + "e1b50ca291833df29403f1239b65deca.svg";